// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList,
  StatsGraph
}                         from '../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import styles      from './style';
import ReactTable from "react-table";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';


class RevenueDetails extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    const search = props.location.search; // returns the URL query String
    const params = new URLSearchParams(search);
    const game = params.getAll('game_type')
    this.state = {
      venue: props.statsTable.revenue_per_month.requested_venue_id,
      game_type: game,
      date: params.get('date'),
      revenue_data:[],
      filtered_data:[],
      headers: [],
      search:'',
      loading: false,
      excel_data:[],
      header:[],
      game_revenue: [],
      amount_by_sport: {}
    };
    this.handleSearch = this.handleSearch.bind(this);
    this.getAmountBySport = this.getAmountBySport.bind(this);

  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');
  }

  componentDidMount() {
    var game_type = this.state.game_type;

    // var game_str = '';
    // if(game_type.length > 1){
    //   game_str = `game_type_id=${game_type[0]}&game_type_id=${game_type[1]}`
    // }
    // else{
    //   game_str = `game_type_id=${game_type[0]}`
    // }
    this.getCustomers(this.state.venue,game_type[0]);

    if(game_type[0] == 'court-booking' ){
      this.getGameBreakUp(this.state.venue)
    }

    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
        fetchStatsGraphDataIfNeeded
      }
    } = this.props;
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  getCustomers(venue,game_type) {
    var url = '';
    console.log('game_type: ' + game_type)
    if(game_type == 'gold' ){
     url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24607&venue_id=${venue}&date=${this.state.date}`;
    }
    else if(game_type == 'silver' ){
      url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24606&venue_id=${venue}&date=${this.state.date}`;
    }
    else if(game_type == 'academy-f' ){
      url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24605&venue_id=${venue}&date=${this.state.date}`;
    }
    else if(game_type == 'academy-b' ){
      url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24604&venue_id=${venue}&${game_type}&date=${this.state.date}`;
    }
    else if(game_type == 'swimming' ){
      url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24602&venue_id=${venue}&${game_type}&date=${this.state.date}`;
    }    
    else if(game_type == 'pay-per-game' ){
      url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24603&venue_id=${venue}&${game_type}&date=${this.state.date}`;
    }    
    else if(game_type == 'court-booking' ){
      url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24610&venue_id=${venue}&${game_type}&date=${this.state.date}`;
    }
    else if(game_type == 'all' ){
      url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24611&venue_id=${venue}&${game_type}&date=${this.state.date}`;
    }
    else if(game_type == 'summercamp' ){
      url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24612&venue_id=${venue}&date=${this.state.date}`;
    }
    else if(game_type == 'skating'){
      url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24613&venue_id=${venue}&date=${this.state.date}`;
    }        
    else if(game_type == 'events'){
      url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24614&venue_id=${venue}&date=${this.state.date}`;
    }    
    // else {
    //   url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=1261&venue_id=${venue}&${game_type}&date=${this.state.date}`;
    // }

    // url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24607&venue_id=${venue}&${game_type}&date=${this.state.date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
          this.setState({
            revenue_data:data.data,headers:data.headers,excel_data:data.excel_data},
            ()=> this.getAmountBySport())
           // alert("fix");
          }
        )
       .catch(error => error);
  }

  getGameBreakUp(venue){
    const url = `${getLocationOrigin()}/eagleeye/getTableData/?report_id=24615&venue_id=${venue}&date=${this.state.date}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {
            this.setState({game_revenue:data.data,header:data.headers})
       }).catch(error => error);
  }

  handleSearch(event){
    const search = event.target.value.toLowerCase()
    const filter_result = this.state.data.filter((venue)=>{
      return venue.name.toLowerCase().indexOf(search) !== -1;
      }
      );
    this.setState({filtered_data:filter_result,search:search})
  }

  getTrProps = (state, rowInfo, instance) => {
      return {
        style: {
          background:'white',
          color:'black'
        }
      };
    };

  getAmountBySport = () => {
    if(this.state.game_type && (this.state.game_type[0] == 'pay-per-game' || this.state.game_type[0] == 'summercamp')) {
      let amountBySport = {}
      let excelData = this.state.excel_data
      let headers= this.state.headers
      let indexOfSport = headers.indexOf('Game')
      let indexOfPay =  this.state.game_type[0] == 'summercamp' ? headers.indexOf("Revenue") : headers.indexOf("Amount") 
      for(let i=0;i<excelData.length;i++) {
        let currentItem = excelData[i]
        if(amountBySport[currentItem[indexOfSport]]) {
          if(this.state.game_type[0] == 'summercamp') {
            amountBySport[currentItem[indexOfSport]] += parseFloat((currentItem[indexOfPay]).replace(/,/g, ''))
          }
          else {
            amountBySport[currentItem[indexOfSport]] += currentItem[indexOfPay]
          }
        }
        else {
          if(this.state.game_type[0] == 'summercamp') {
            amountBySport[currentItem[indexOfSport]] =  parseFloat((currentItem[indexOfPay]).replace(/,/g, ''))
          }
          else {
            amountBySport[currentItem[indexOfSport]] = currentItem[indexOfPay]
          }
        }
      }
      this.setState({
        amount_by_sport: amountBySport
      })
    }
  }

 formatIndianCurrency = (num) => {
    return num.toLocaleString('en-IN')
  };


  renderGameRevenue(){  
    return(
      <div style={{
        display: this.state.game_revenue.length == 0 ? 'none' : 'flex',
        flexDirection: 'column',
        padding: '15px',
        marginBottom: '20px',
        backgroundColor: '#fff',
        borderRadius: '5px',
        boxShadow: '0px 0px 2px 0px rgba(0,0,0,0.2)'
      }}>
        <div style={styles.breakUpContainer}>
          {
            this.state.game_revenue.map((game, index) => (
              <div key={index} style={styles.statContainer}>
                <div style={styles.statLabel}>{game[0]}</div>
                <div style={styles.statValue}><i className="fa fa-inr" aria-hidden="true"></i>{game[1]}</div>
              </div>
            ))
          }
        </div>
      </div>
    )
  }

  renderCutsomers(){
    console.log('render customer')
    console.log(this.state.date +' Revenue')
    
    var excelName = this.state.date +' Revenue'
    var headers = []
    if(this.state.revenue_data.length > 0){
      headers = Object.keys(this.state.revenue_data[0])
    }
    
    const headings = this.state.headers.map(function(element,index){
      var heading = {};
      heading["name"] = element;
      heading["accessor"] = index.toString();//For react-table
      heading["displayName"] = element;
      heading["Header"] = element; //For react-table
      heading["sortable"] = true;
      heading["inputFilterable"] = true;
      heading["visible"] = (element.indexOf("_hidden") == -1);
      heading["show"] = (element.indexOf("_hidden") == -1);
      heading["render"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;
      heading["Cell"] =  props => <span dangerouslySetInnerHTML={{__html: props.value}}  ></span>;// Custom cell components for react-table
      return heading;
    });

    return(
      <div>
        {
        this.state.amount_by_sport && this.state.game_type && (this.state.game_type[0] == 'pay-per-game' || this.state.game_type[0] == 'summercamp') &&
          <div
            style={styles.am_sport_container}
          >
            {
              Object.entries(this.state.amount_by_sport).map(([key, value]) => (
                <div
                  key={key}
                  style={styles.am_sport_card}
                  onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.02)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'scale(1.0)'}
                >
                  <div style={styles.card_title}>
                    {key}
                  </div>
                  <div style={styles.card_value}>
                    <i className="fa fa-inr" aria-hidden="true"></i> {this.formatIndianCurrency(value)}
                  </div>
                </div>
              ))
            }
          </div>
        }

        {/*<div style={{float:'right',marginBottom:'1%'}}>
      
          <ReactHTMLTableToExcel
                      id="test-table-xls-button"
                      className="download-table-xls-button btn btn-primary"
                      table="table-to"
                      filename={excelName}
                      sheet={excelName}
                      buttonText="Download as XLS"/>

        </div>*/}
             
      <div className='col-md-12 table_container1 table-responsive' style={styles.table}>

         <div className="heading left" style={{marginTop:'1%',borderRadius:'5px',boxShadow: '0px 0px 2px 0px',display:'flex',justifyContent: 'space-between'}}>
          <span style={{fontWeight: 'bold',fontSize:'18px'}}> Revenue List </span>
          <ReactHTMLTableToExcel
                      id="test-table-xls-button"
                      className="download-table-xls-button btn btn-primary"
                      table="table-to"
                      filename={excelName}
                      sheet={excelName}
                      buttonText="Download as XLS"/>
        </div> 

        {/*<div className="heading heading2 left" style={styles.header}>Revenue List</div> */}
        { this.state.revenue_data.length > 0 ?
        <ReactTable  
                      data={this.state.revenue_data}  
                      columns={headings}  
                      defaultPageSize = {100}  
                      pageSizeOptions = {[100,200,500]} 
                      filterable={true}
                      showPagination={this.state.revenue_data.length > 100}
                      showPaginationTop = {this.state.revenue_data.length > 100}
                      style = {{background:'#ddd'}}
                      getTrProps = {this.getTrProps}
                      defaultFilterMethod = {(filter, row, column) => {
                        const id = filter.pivotId || filter.id
                        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                      }}
                     
          >
          {
                //To show the record count on top  
                (state, makeTable, instance) => {

                  let recordsInfoText = "";

                  const { filtered, pageRows, pageSize, sortedData, page } = state;

                  if (sortedData && sortedData.length > 0) {
                    let isFiltered = filtered.length > 0;

                    let totalRecords = sortedData.length;

                    let recordsCountFrom = page * pageSize + 1;

                    let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                    if (isFiltered){
                      recordsInfoText = `${totalRecords} filtered records`;
                    }
                    else {
                      recordsInfoText = `${totalRecords} records`;
                    }
                  } else {
                      recordsInfoText = "No records";
                    }
                  return (
                    <div className="main-grid">
                      <div className="above-table text-right">
                        <div className="col-sm-12 records-info">
                          <span className="">{recordsInfoText}</span>
                        </div>
                      </div>
                      {makeTable()}
                      
                    </div>

                  );
                }
              }
          </ReactTable>
          :
          this.state.headers.length > 0 ?
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
            </div>
            :
            <div style={{height:500}}>
              <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> <Spinner size="50" /></div>
            </div>
        }
      </div>
      <table id="table-to" style={{display:'none'}}>
        <tr> {headers.map((head)=><th>{head}</th>)}</tr>
          {this.state.excel_data.map((data)=>
                <tr>
                  { data.map((each)=>
                    <td >{each}</td>
                    )
                  }
                </tr>
                )}
      </table>
    </div>
      )
  }

  render() {
    console.log('----state----',this.state)

    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    
    console.log('props data',this.state.game_type)
    console.log('revenue_data',this.state.revenue_data)
    return(
      <div>
        
        <div>
             <div className="breadcrumps" style={{marginBottom:'2%'}}>
                        <a href={'/#/dashboard/ActiveCustomer'} >
                          <span>Dashboard</span>
                        </a> 
                        <a href={'/#/dashboard/RevenueDetails'} >
                          <span>Revenue Summary</span>
                        </a>
                        {/*
                        <a  onClick={()=>this.props.history.goBack()}>
                          <span>Daily Revenue</span>
                        </a>
                      */}
                        <a>
                          <span>Revenue List</span>
                        </a>  
          </div>
          {this.renderGameRevenue()}
          {this.renderCutsomers()}
        </div>
      </div>
    );
  }
}

export default RevenueDetails;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/RevenueDetails/RevenueDetails.js